<template>
  <div>
    <h2>{{ t('listingDocuments.title') }} ({{ listingDocuments?.length ?? 0 }})</h2>
    <ul v-if="hasListingDocuments" :class="$style.links">
      <li
        v-for="listingDocument in listingDocuments"
        :key="listingDocument.label"
        :class="$style.linkItem"
      >
        <HgLink
          icon="Document"
          :href="listingDocument.href"
          rel="noopener noreferrer"
          target="_blank"
          @click="emit('documentClick')"
        >
          {{ listingDocument.label || t('buttons.attachedDocument') }}
        </HgLink>
      </li>
    </ul>
  </div>
</template>

<script lang="ts" setup>
import { HgLink } from '@smg-real-estate/domus';
import { L10N } from '@smg-real-estate/hg-rets-schema';
import { computed } from 'vue';

import { getListingAttachedDocument } from '@/helpers/ListingData/ListingData';
import { HgListingAttachedDocument } from '@/models';
import { useI18n } from 'vue-i18n';

const { t } = useI18n();

defineOptions({
  name: 'ListingDocuments',
});

interface Props {
  listingDefaultLocale: L10N | undefined;
}
const props = defineProps<Props>();

const emit = defineEmits<{
  documentClick: [];
}>();

const hasListingDocuments = computed((): boolean => {
  return !!listingDocuments.value && listingDocuments.value.length > 0;
});

const listingDocuments = computed<HgListingAttachedDocument[] | undefined>(() => {
  return props.listingDefaultLocale
    ? getListingAttachedDocument(props.listingDefaultLocale)
    : undefined;
});
</script>

<style lang="scss" module>
@import '@/assets/variables';

$link-min-width: 70px;
$link-min-width-vp-large: 55px;
$link-label-max-width: 200px;
$listing-accessories-min-height: 2em;
$item-max-width: 460px;

.links {
  display: flex;
  flex-flow: column nowrap;
  gap: $space-75;
  max-width: 100%;
  min-height: $listing-accessories-min-height;

  @include menu-ul-reset;
}

.linkItem {
  @include body-2;

  min-width: $link-min-width;
  vertical-align: middle;

  a {
    span {
      display: block;
      max-width: $item-max-width;

      @include truncate-text;
    }
  }
}
</style>
